import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux-immutable';
import { fromJS } from 'immutable';
var individualResults = handleActions({
  SET_INDIVIDUAL_RESULTS: function SET_INDIVIDUAL_RESULTS(state, action) {
    return fromJS(action.payload || []);
  }
}, null);
var state = handleActions({
  SET_INDIVIDUAL_RESULTS_STATE: function SET_INDIVIDUAL_RESULTS_STATE(state, action) {
    return action.payload;
  }
}, 'closed');
export default combineReducers({
  individualResults: individualResults,
  state: state
});